import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo-head";
import AgencyHome from "@/pages/AgencyHome";
import heroPoster from "@/assets/jaik-construction-montage-poster.jpg.asset.json";

export const Route = createFileRoute("/")({
  component: AgencyHome,
  head: () => {
    const head = pageHead({
      title: "Seattle Contractor Web Design & SEO | jaik",
      description: "Contractor web design and SEO for Seattle trades (roofing, remodeling, plumbing). Get 10-20 leads/mo. Free mockup for King County businesses. Book now.",
      path: "/",
    });
    return {
      ...head,
      links: [
        ...head.links,
        // Largest paint element on the home page: fetch it as early as possible.
        { rel: "preload", as: "image", href: heroPoster.url, fetchPriority: "high" },
      ],
    };
  },
});
